module.exports = __webpack_public_path__ + "static/media/list-hash.b72a0bf4.svg";